export enum RegisterDirection {
  Consumption = 'consumption',
  Production = 'production'
}
